// eslint-disable-next-line
const copyToClipboard = require('copy-to-clipboard');

export default copyToClipboard as (text: string) => boolean;
